export { Input, type InputProps } from '@/shared/ui/shadcn/input';
